import upperFirst from 'lodash/upperFirst'
import { formatUserName } from './formatUserName'
import { User } from './types'

// fallbackName must arrive already translated — there is no translator here.
type GetCommentAuthorNameArgs = {
  user: (Pick<User, 'firstName' | 'lastName'> & { isArchived?: boolean }) | null
  integration?: string
  includeInactiveTag?: boolean
  fallbackName?: string
}

export const getCommentAuthorName = (args: GetCommentAuthorNameArgs): string => {
  const { user, integration, includeInactiveTag = false, fallbackName } = args
  if (user) {
    const { firstName, lastName, isArchived } = user
    return includeInactiveTag && isArchived !== undefined
      ? formatUserName({ firstName, lastName, isArchived })
      : `${firstName} ${lastName}`
  }
  if (fallbackName) return fallbackName
  if (integration) return upperFirst(integration)
  return 'Omnea'
}
